// src/components/Charts/AreaChart.js
import React from "react";
import {
  AreaChart as ReAreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
} from "recharts";

const AreaChart = ({
  data = [],
  xKey = "month",
  areas = [{ key: "amount", stroke: "#10b981", fill: "#10b981", name: "Amount ($)" }],
  showLegend = false,
}) => {
  return (
    <ReAreaChart data={data}>
      <CartesianGrid
        strokeDasharray="3 3"
        stroke="#e5e7eb"
        className="dark:stroke-gray-700"
      />

      <XAxis
        dataKey={xKey}
        stroke="#6b7280"
        tick={{ fill: "#6b7280" }}
        className="dark:stroke-gray-400"
      />

      <YAxis
        stroke="#6b7280"
        tick={{ fill: "#6b7280" }}
        className="dark:stroke-gray-400"
      />

      <Tooltip
        contentStyle={{
          backgroundColor: "var(--tooltip-bg, #ffffff)",
          border: "1px solid #e5e7eb",
          borderRadius: "12px",
        }}
        wrapperClassName="dark:[--tooltip-bg:#1f2937] dark:text-gray-200"
      />

      {showLegend ? (
        <Legend wrapperStyle={{ color: "#374151" }} className="dark:text-gray-300" />
      ) : null}

      {areas.map((a) => (
        <Area
          key={a.key}
          type="monotone"
          dataKey={a.key}
          stroke={a.stroke}
          fill={a.fill}
          fillOpacity={a.fillOpacity ?? 0.3}
          name={a.name}
        />
      ))}
    </ReAreaChart>
  );
};

export default AreaChart;